class TabLayout {
  constructor(selector, { adaptiveHeight = false }) {
    this.el = document.querySelector(selector);
    this.options = { adaptiveHeight };

    this.defaultTab();
    this.initTabLayout();
  }

  defaultTab() {
    const activeTab = this.el.getElementsByClassName(
      "tab-layout__tab--active"
    )[0];
    if (!activeTab) {
      this.setActiveTab(0);
      this.moveViewPager(0);
    } else {
      // Move view pager to active tab
      const activeTabIndex = this.getElementIndex(activeTab);
      this.moveViewPager(activeTabIndex);
    }

    this.setTabsLine();
  }

  initTabLayout() {
    const tabs = this.el.getElementsByClassName("tab-layout__tab");
    for (let i = 0; i < tabs.length; i++) {
      const tab = tabs[i];
      tab.addEventListener("click", () => {
        this.setActiveTab(i);
        this.moveViewPager(i);
        this.setTabsLine();
      });
    }
  }

  getElementIndex(element) {
    return [...element.parentNode.children].indexOf(element);
  }

  setActiveTab(index) {
    const activeTab = this.el.getElementsByClassName(
      "tab-layout__tab--active"
    )[0];
    if (activeTab) activeTab.classList.remove("tab-layout__tab--active");

    const selectedTab = this.el.getElementsByClassName("tab-layout__tab")[
      index
    ];
    selectedTab.classList.add("tab-layout__tab--active");
  }

  moveViewPager(index) {
    const viewpagerWrapper = this.el.getElementsByClassName(
      "tab-layout__viewpager-wrapper"
    )[0];
    const percentage = `-${index * 100}%`;
    viewpagerWrapper.style.transform = `translate3d(${percentage}, 0, 0)`;

    if (this.options.adaptiveHeight) {
      const viewpagerItem = this.el.getElementsByClassName(
        "tab-layout__viewpager-item"
      )[index];
      viewpagerWrapper.style.height = `${viewpagerItem.scrollHeight}px`;
    }
  }

  setTabsLine() {
    const activeTab = this.el.getElementsByClassName(
      "tab-layout__tab--active"
    )[0];
    const tabText = activeTab.getElementsByClassName("tab-layout__tab-text")[0];

    const tabLeft = tabText.offsetLeft;
    const tabWidth = tabText.offsetWidth;
    this.moveTabsLine(tabLeft, tabWidth);
  }

  moveTabsLine(offsetLeft, width) {
    const tabsLine = this.el.getElementsByClassName("tab-layout__tabs-line")[0];
    tabsLine.style.width = `${width}px`;
    tabsLine.style.left = `${offsetLeft}px`;
  }
}

export default TabLayout;
